import { Injectable } from '@angular/core';
import { Logradouro, TipoLogradouro } from '@tivic-team/manager-ts/dist/grl';
import { TipoLogradouroDTO } from 'app/model/dtos/grl/tipo-logradouro.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';

@Injectable()
export class TipoLogradouroController {

    constructor() { }
    
    async find(filtros?:IFilter):Promise<Array<TipoLogradouro>>{	
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/tipologradouro',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<TipoLogradouro>()
			)
		);
		return await quark.call();
	}

	async get(cdTipoLogradouro:number):Promise<TipoLogradouroDTO>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/tipologradouro/gettipologradouro/:cdTipoLogradouro',
					environment: environment,
					pathParams: new JSONData({cdTipoLogradouro: cdTipoLogradouro})
				}),
			}),
			new HttpResponse(
				new TipoLogradouroDTO()
			)
        );
        return await quark.call();
	}

	async create(logradouro: Logradouro):Promise<Logradouro>{
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/tipologradouro',
					environment: environment
				}),
				data: new JSONData(logradouro)
			}),
			new HttpResponse(
				new Logradouro()
			)
		);
		return await quark.call();
	}
	
	async createTipoLogradouro( tipoLogradouro: TipoLogradouro):Promise< TipoLogradouro >{
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/tipologradouro',
					environment: environment
				}),
				data: new JSONData(tipoLogradouro)
			}),
			new HttpResponse(
				new TipoLogradouro()
			)
		);
		return await quark.call();
	}

	async update(tipoLogradouro: Logradouro):Promise<Logradouro>{
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'grl/tipologradouro/:cdTipoLogradouro', 
					environment: environment, 
					pathParams: new JSONData({cdTipoLogradouro: tipoLogradouro.cdTipoLogradouro})
				}),
				data: new JSONData(tipoLogradouro)
			}),
			new HttpResponse(
				new Logradouro()
			)
		);
		return await quark.call();
	}

	async updateTipoLogradouro( tipoLogradouro: TipoLogradouro ): Promise< TipoLogradouro > {
		let quark = new Quark(
			new HttpPut( {
				url: new Url( {
					id: 'grl/tipologradouro/:cdTipoLogradouro',
					environment: environment,
					pathParams: new JSONData({ cdTipoLogradouro: tipoLogradouro.cdTipoLogradouro })
				}),
				data: new JSONData( tipoLogradouro )
			}),
			new HttpResponse( 
				new TipoLogradouro()
			)
		)

		return await quark.call();
	}

}